// extracted by mini-css-extract-plugin
export default {"isHighlightedAdmittance":"ResourceCell_isHighlightedAdmittance_ffabf"};